import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { ChildrenOutletContexts, Router } from '@angular/router';
import { ConnectionStatusService } from '@shared/services/connection-status.service';
import { UpdateService } from '@shared/services/update.service';
import { routeAnimations } from './animations/route-animations';
import { ApiCacheService } from '@shared/services/api-cache.service';
import { AuthService } from '@shared/services/auth.service';
import { NavigationService } from '@shared/services/navigation.service';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit {
  currentScreen?: 'calendar' | 'sequence' | 'flight' | null;
  isAuthenticated = this.authService.isAuthenticated;
  isAuthError = this.authService.isAuthError;

  constructor(
    private authService: AuthService,
    private contexts: ChildrenOutletContexts,
    private connectionStatusService: ConnectionStatusService,
    private updateService: UpdateService,
    private cacheService: ApiCacheService,
    private navigationService: NavigationService,
    private themeService: ThemeService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Return to previously viewed screen if certain conditions are met.
    // this.navigationService.navigateToLastUrl();
    this.themeService.initThemeWatcher();

    // Init connection status notifications.
    this.connectionStatusService.init();

    // Init update alerts and update checking.
    this.updateService.init();

    // Clear old unused items from local storage.
    this.cacheService.clearOldCache();
  }

  ngAfterViewInit(): void {
    // Init auth service.
    // Initializing after view init helps with nonce errors in mobile app.
    this.authService.init();
  }

  getRouteAnimationData(): void {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'screenIndex'
    ];
  }

  onBackClick(): void {
    this.navigationService.back();
  }

  retryAuth(): void {
    this.authService.manualRetry();
    this.router.navigate(['calendar']);
  }
}
